import { z } from 'zod';

export const paginationSchema = z.object({
  page: z.coerce.number().int().positive(),
  size: z.coerce.number().int().positive(),
});

export type Pagination = z.infer<typeof paginationSchema>;
